import { transactionRoute } from './transaction';

export const allTransactionRoutes = [transactionRoute()];
